import { Injectable } from '@angular/core';
import * as amplitude from 'amplitude-js';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private API_KEY = '1aabe9c9be9ecda2b701d20c2178c420';
  public isReady: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private userService: UserService) {
    amplitude.getInstance().init(this.API_KEY);
    this.userService.user.subscribe(async (u) => {
      if (u && u.email) {
        await amplitude.getInstance().setUserId(u.email);
        this.isReady.next(true);
      }
    });
  }

  public event(e: any, props: any = {}): void {
    amplitude.getInstance().logEvent(e, props);
  }

  updateUserProperties(props): void {
    amplitude.setUserProperties(props);
  }
}
